import { useEffect, useState } from "react";
import ActivityTabs from "./ActivityTabs";
import ActivityTabContent from "./components/MyActivity/ActivityTabContent";
import UnstakeTabContent from "./components/MyUnstakes/UnstakeTabContent";


export default function ActivitySection({ by, contractAddress, token, claimContract, tokenDecimals  }) {
  const [activeTab, setActiveTab] = useState("activities");


  const unstakeData = [
    {
      unstakedOn: "Sep 01, 2025",
      unstakedTime: "07:02 PM",
      availableIn: "00D:00M:00S",
      availableClass: "greenline",
      amount: "25,000 OASIS",
      canWithdraw: true,
    },
    {
      unstakedOn: "Sep 01, 2025",
      unstakedTime: "07:02 PM",
      availableIn: "00D:00M:00S",
      availableClass: "yellowtext",
      amount: "25,000 OASIS",
      canWithdraw: false,
    },
  ];

  // ✅ Fetch Activities

  return (
    <div className="tabs_newwww">
      <ActivityTabs activeTab={activeTab} setActiveTab={setActiveTab} />

      <div className="tab-content" id="myTabContent">
        {/* ✅ Activities Tab */}
        {activeTab === "activities" && (
          <div
            className="tab-pane fade show active"
            id="home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <ActivityTabContent by ={by} contractAddress={contractAddress} token={token} tokenDecimals={tokenDecimals} />
          </div>
        )}

        {/* ✅ Unstake Tab */}
        {activeTab === "unstake" && (
          <div
            className="tab-pane fade show active"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <UnstakeTabContent staker={by} contractAddress={contractAddress} claimContract={claimContract} token={token} tokenDecimals={tokenDecimals}/>
            {/* <Mobileunstake/> */}
          </div>
        )}
      </div>
    </div>
  );
}
